import { Box, Typography } from "@mui/material";
import { Icon } from "../../../icons";
import { OssPanel } from "./OssPanel";

export const OssMetricCards = ({
  items = [],
  columns = { xs: 2, lg: 4 },
  activeKey = "",
  onItemClick,
}) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: {
        xs: `repeat(${columns.xs || 2}, minmax(0, 1fr))`,
        md: `repeat(${columns.md || columns.lg || 4}, minmax(0, 1fr))`,
        lg: `repeat(${columns.lg || 4}, minmax(0, 1fr))`,
      },
      gap: 1.2,
    }}
  >
    {items.map((item) => {
      const tone = item.tone || "#6c5ce7";
      const clickable = Boolean(item.filterKey && onItemClick);
      const active = clickable && activeKey === item.filterKey;

      return (
        <OssPanel
          key={item.label}
          onClick={clickable ? () => onItemClick(item.filterKey) : undefined}
          onKeyDown={
            clickable
              ? (event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onItemClick(item.filterKey);
                  }
                }
              : undefined
          }
          role={clickable ? "button" : undefined}
          tabIndex={clickable ? 0 : undefined}
          sx={{
            minHeight: 90,
            p: 1.7,
            display: "flex",
            alignItems: "center",
            gap: 1.2,
            borderColor: active ? tone : item.borderColor || "#e5e7eb",
            bgcolor: active ? `${tone}08` : "#fff",
            boxShadow: active
              ? `0 0 0 1px ${tone}22, 0 8px 20px rgba(15, 23, 42, 0.06)`
              : undefined,
            cursor: clickable ? "pointer" : "default",
            transition: "border-color 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease",
            "&:hover": clickable
              ? {
                  borderColor: tone,
                  boxShadow: "0 8px 20px rgba(15, 23, 42, 0.065)",
                }
              : undefined,
            "&:focus-visible": clickable
              ? {
                  outline: `2px solid ${tone}`,
                  outlineOffset: 2,
                }
              : undefined,
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              flexShrink: 0,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              bgcolor: `${tone}14`,
              color: tone,
              "& svg": {
                display: "block",
                width: 20,
                height: 20,
                margin: 0,
              },
            }}
          >
            {item.iconName ? <Icon name={item.iconName} width={20} height={20} /> : item.icon}
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography noWrap sx={{ fontSize: 12.5, color: "#64748b", lineHeight: 1.25 }}>
              {item.label}
            </Typography>
            <Typography
              noWrap
              sx={{
                mt: 0.25,
                fontSize: "25px !important",
                fontWeight: "900 !important",
                lineHeight: 1,
                color: item.valueColor || "#111827",
              }}
            >
              {item.value}
              {item.unit && (
                <Box component="span" sx={{ ml: 0.25, fontSize: 12, fontWeight: 700, color: "#64748b" }}>
                  {item.unit}
                </Box>
              )}
            </Typography>
            {item.helper && (
              <Typography noWrap sx={{ mt: 0.45, fontSize: 12, color: "#64748b" }}>
                {item.helper}
              </Typography>
            )}
          </Box>
        </OssPanel>
      );
    })}
  </Box>
);
